import React, { useEffect } from "react";

interface ThankYouProps {
  data: any;
  onStartNew: () => void;
}

export const ThankYou: React.FC<ThankYouProps> = ({ data, onStartNew }) => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleStartNew = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    onStartNew();
  };

  return (
    <div className="card mb-5 mb-xl-10">
      <div className="card-header border-0 p-4 p-lg-5 d-flex flex-column flex-sm-row align-items-center text-center text-sm-start">
        <div className="me-sm-4 mb-3 mb-sm-0" style={{ flexShrink: 0 }}>
          <img
            src="/media/logos/logo-2.svg"
            alt="Swaminarayan Gadi Logo"
            style={{
              width: "clamp(50px, 12vw, 60px)",
              height: "clamp(50px, 12vw, 60px)",
              objectFit: "contain",
            }}
          />
        </div>
        {/* Title */}
        <div className="flex-grow-1">
          <h3 className="card-title fw-bolder fs-4 fs-lg-3 mb-1">
            Maninagar Shree Swaminarayan Gadi Sansthan
          </h3>
          <span className="card-label fs-5 fs-lg-4">
            Shree Swaminarayan Gadi Parivar Registration Form
          </span>
        </div>
      </div>

      <div className="card-body border-top p-9">
        {/* Success Message */}
        <div className="text-center mb-8">
          <div className="mb-6">
            <i
              className="fas fa-check-circle text-success"
              style={{ fontSize: "4rem" }}
            ></i>
          </div>
          <h2 className="card-title fw-bolder fs-2 mb-4 text-success">
            Registration Submitted Successfully!
          </h2>
          <p className="fs-4 text-muted mb-6">
            Thank you for registering with Maninagar Shree Swaminarayan Gadi
            Sansthan
          </p>
        </div>

        {/* Registration Summary */}
        <div className="alert alert-primary p-6 mb-8">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h4 className="alert-heading fw-bold mb-3">
                <i className="fas fa-info-circle me-2"></i>
                What happens next?
              </h4>
              <div className="mb-3">
                <p className="mb-2">
                  <strong>📧 Confirmation Email:</strong> You will receive a
                  confirmation email shortly at{" "}
                  <span className="text-primary fw-bold">{data.email}</span>
                </p>
                <p className="mb-2">
                  <strong>🔍 Verification Process:</strong> A representative of
                  your local mandir/mandal will review your registration details
                </p>
                <p className="mb-2">
                  <strong>📱 Contact:</strong> We may contact you at{" "}
                  <span className="text-primary fw-bold">
                    {data.mobileCountryCode} {data.mobileNumber}
                  </span>{" "}
                  if additional information is needed
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Registered Details Summary */}
        <div className="row mb-8">
          <div className="col-md-12">
            <div className="card card-flush bg-light-info">
              <div className="card-body p-6">
                <h5 className="card-title fw-bold mb-4">
                  <i className="fas fa-user me-2"></i>
                  Registration Summary
                </h5>
                <div className="mb-3">
                  <label className="fw-bold fs-7 text-muted">Full Name</label>
                  <div className="fs-6 fw-semibold">
                    {data.firstName} {data.middleName} {data.lastName}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="fw-bold fs-7 text-muted">Email</label>
                  <div className="fs-6 fw-semibold">{data.email}</div>
                </div>
                <div className="mb-3">
                  <label className="fw-bold fs-7 text-muted">
                    Mobile Number (WhatsApp)
                  </label>
                  <div className="fs-6 fw-semibold">
                    {data.mobileCountryCode} {data.mobileNumber}
                  </div>
                </div>
                <div className="mb-0">
                  <label className="fw-bold fs-7 text-muted">
                    Registration Date
                  </label>
                  <div className="fs-6 fw-semibold">
                    {new Date().toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary btn-lg px-8"
            onClick={handleStartNew}
          >
            <i className="fas fa-plus me-2"></i>
            Register Another Satsangi
          </button>
        </div>
      </div>
    </div>
  );
};
